import { WhiteInstantSearchBuilder } from '@white-nl/instantsearch-components';
import Hit from './components/results/Hit';
import Pagination from '../components/Pagination';
import Stats from './components/results/Stats';
import SortBy from '../components/SortBy';
import CurrentRefinements from './components/refinements/CurrentRefinements/CurrentRefinements';
import ProductRefinements from './components/refinements/ProductRefinements';
import FilterSidebar from './components/refinements/FilterSidebar';

const whiteInstantSearchBuilder = new WhiteInstantSearchBuilder();
const productOverview = document.getElementById('product-overview');
const settings = productOverview?.dataset || null;
const productOverviewActionUrl = settings?.productOverviewUrl;
const sessionUrl = settings?.sessionUrl;

const groups: string[] = [];
const currentLevel = settings?.level ? parseInt(settings.level, 10) : 1;
for (let i = 1; i <= currentLevel; i += 1) {
  groups.push(`productGroups.lvl${i}`);
}

if (productOverview && settings && sessionUrl && productOverviewActionUrl) {
  fetch(sessionUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  }).then((res) => res.json())
    .then((sessionData) => {
      fetch(productOverviewActionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ groupId: settings.currentGroupId, blockId: settings.blockId }),
      }).then((res) => res.json())
        .then((data) => {
          const indexName = settings.indexName || '';
          const {
            groupSpecTypes,
            featuredSpecTypes,
            groupMapping,
            translates,
          } = data;
          const { catalog } = translates;
          whiteInstantSearchBuilder
            .withSearchkit(
              indexName,
              settings.publicUrl || '',
              settings.jwt || '',
              settings.refreshUrl || '',
            )
            .addAdditionalData(
              {
                indexName,
                title: settings.title,
                productSpecTypes: groupSpecTypes,
                featuredSpecTypes,
                productGroups: groups,
                groupMapping,
                pathAttribute: settings.pathAttribute,
                addToPath: settings.isGroup !== undefined,
                addTrailingSlashesToUrls: true,
                isGroup: settings.isGroup !== undefined,
                groupId: settings.currentGroupId,
                parentGroupUri: settings.parentGroupUri,
                groupLevel: settings.level || null,
                itemsPerRow: parseInt(settings.itemsPerRow || '2', 10),
                showGroups: settings.showGroups,
                showFeaturedFilters: settings.showFeaturedFilters,
                showPromotionFilter: settings.showPromotionFilter,
                csrfTokenName: sessionData.csrfTokenName,
                csrfTokenValue: sessionData.csrfTokenValue,
                wishlistType: settings.wishlistType,
                catalog,
              },
            )
            .withWhiteInstantSearchRouting(
              {
                baseUrl: settings.baseUrl,
                pathAttribute: settings.pathAttribute,
                addToPath: settings.isGroup !== undefined,
                addTrailingSlashesToUrls: true,
              },
            )
            .setScrolling(
              {
                includeAttributes: ['page'],
              },
            )
            .addSearchingComponent(
              [
                {
                  settings: {
                    placeholder: Craft.t(catalog, 'Zoek iets...'),
                    classNames: {
                      form: 'search-header h-12',
                      input: '!h-full',
                      submit: 'hidden',
                      reset: 'hidden',
                      loadingIndicator: 'hidden',
                    },
                  },
                },
              ],
            )
            .registerContainer(
              ProductRefinements,
              '#white-instant-search-refinements',
            )
            .registerContainer(
              FilterSidebar,
              '#white-instant-search-sidebar-refinements',
            )
            .addHiddenHierarchicalMenu(
              [
                {
                  settings: {
                    attributes: groups,
                    separator: '/',
                    rootPath: settings.currentGroupUri,
                    hardRefresh: settings.isGroup !== undefined,
                    limit: 99,
                  },
                },
              ],
            )
            .addHiddenToggleRefinement(
              [
                {
                  settings: {
                    attribute: 'onPromotion',
                  },
                },
              ],
            )
            .addStatsComponent(
              [
                {
                  settings: {
                    translations: {
                      resultFound: settings.isGroup ? Craft.t(catalog, '{title} gevonden', { title: settings.title }) : Craft.t(catalog, 'resultaat gevonden'),
                      resultsFound: settings.isGroup ? Craft.t(catalog, '{title} gevonden', { title: settings.title }) : Craft.t(catalog, 'resultaten gevonden'),
                    },
                  },
                  component: Stats,
                },
              ],
            )
            .addSortByComponent(
              [
                {
                  settings: {
                    items: [
                      {
                        label: Craft.t(catalog, 'Meest relevant'),
                        value: indexName,
                      },
                      {
                        label: Craft.t(catalog, 'Title (A-z)'),
                        value: `${indexName}_title_asc`,
                      },
                      {
                        label: Craft.t(catalog, 'Title (Z-a)'),
                        value: `${indexName}_title_desc`,
                      },
                      {
                        label: Craft.t(catalog, 'Prijs (Laag naar hoog)'),
                        value: `${indexName}_price_asc`,
                      },
                      {
                        label: Craft.t(catalog, 'Prijs (Hoog naar laag)'),
                        value: `${indexName}_price_desc`,
                      },
                      {
                        label: Craft.t(catalog, 'Datum (Recent naar oud)'),
                        value: `${indexName}_date_desc`,
                      },
                      {
                        label: Craft.t(catalog, 'Datum (Oud naar recent)'),
                        value: `${indexName}_date_asc`,
                      },
                    ],
                  },
                  component: SortBy,
                },
              ],
            )
            .addCurrentRefinementsComponent(
              [
                {
                  settings: {
                    excludedAttributes: [
                      ...groups,
                    ],
                  },
                  component: CurrentRefinements,
                },
              ],
            )
            .addHitComponent(
              [
                {
                  settings: {
                    noResults: {
                      translations: {
                        noResults: Craft.t(catalog, 'Er zijn geen resultaten gevonden'),
                        refinements: ' ',
                        query: ' ',
                      },
                    },
                  },
                  component: Hit,
                },
              ],
            )
            .addPaginationComponent(
              [
                {
                  settings: {
                    translations: {
                      nextPageItemAriaLabel: Craft.t(catalog, 'Volgende'),
                      previousPageItemAriaLabel: Craft.t(catalog, 'Vorige'),
                    },
                  },
                  component: Pagination,
                },
              ],
            )
            .setHitsPerPage(12)
            .afterRender(() => {
              const searchInput = document.querySelector('input.ais-SearchBox-input') as HTMLInputElement | null;
              if (searchInput) {
                const headerSearchInput = document.getElementById('header-search') as HTMLInputElement;
                if (headerSearchInput) {
                  headerSearchInput.value = searchInput.value;
                }
              }
            });

          if (groupSpecTypes) {
            Object.keys(groupSpecTypes).forEach((spec: string) => {
              const dataType = groupSpecTypes[spec];
              if ([1, 2].includes(parseInt(dataType, 10))) {
                whiteInstantSearchBuilder
                  .addHiddenMenu(
                    [
                      {
                        settings: {
                          attribute: spec,
                          limit: 99,
                        },
                      },
                    ],
                  );
              } else {
                whiteInstantSearchBuilder
                  .addHiddenRefinementList(
                    [
                      {
                        settings: {
                          attribute: spec,
                          limit: 99,
                        },
                      },
                    ],
                  );
              }
            });
          }

          if (settings.brand !== undefined) {
            whiteInstantSearchBuilder
              .where(`productBrand:${settings.brand}`);
          }
          const onlyShowSaleProductsRaw = settings.onlyShowSaleProducts;
          const onlyShowSaleProducts = onlyShowSaleProductsRaw === '1';
          if (onlyShowSaleProducts) {
            whiteInstantSearchBuilder
              .where('onPromotion:true');
          }
          if (settings.isGroup === undefined && settings.currentGroupUri) {
            whiteInstantSearchBuilder
              .where(`productGroups.lvl${settings.currentGroupUri.split('/').length}:"${settings.currentGroupUri}"`);
          }

          whiteInstantSearchBuilder
            .build()
            .show();
        });
    });
}
